import { useState, useEffect } from "react";
import { useAdminApi, fmtDate } from "../../adminUtils";

export default function PassAlertsReport() {
  const { API, AUTH } = useAdminApi();
  const [alerts, setAlerts]             = useState([]);
  const [loading, setLoading]           = useState(false);
  const [reminderState, setReminderState] = useState("idle");

  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    setLoading(true);
    setLoadError(false);
    fetch(`${API}/reports/pass-alerts`, { headers: AUTH })
      .then(r => r.json()).then(d => setAlerts(d.alerts ?? []))
      .catch(() => setLoadError(true)).finally(() => setLoading(false));
  }, [API, AUTH]);

  const handleSendReminders = async () => {
    setReminderState("sending");
    try {
      await fetch(`${API}/reports/pass-alerts/remind-all`, {
        method: "POST", headers: AUTH, body: JSON.stringify({ alerts }),
      });
      setReminderState("sent");
    } catch { setReminderState("idle"); }
  };

  return (
    <div>
      {loading && <p className="adm-loading">Loading…</p>}
      {loadError && <p className="adm-error">Couldn't load pass alerts — check your connection and refresh.</p>}
      {!loading && !loadError && alerts.length === 0 && (
        <p className="adm-empty">No passes expiring soon or running low.</p>
      )}
      {!loading && alerts.length > 0 && (
        <>
          {reminderState === "idle"    && <button className="adm-btn adm-btn--remind" onClick={() => setReminderState("confirm")}>Send reminders to {alerts.length} student{alerts.length !== 1 ? "s" : ""}</button>}
          {reminderState === "confirm" && <div className="adm-remind-confirm"><span>Send to {alerts.length} student{alerts.length !== 1 ? "s" : ""}?</span><button className="adm-btn adm-btn--primary" onClick={handleSendReminders}>Yes, send</button><button className="adm-btn adm-btn--ghost" onClick={() => setReminderState("idle")}>Cancel</button></div>}
          {reminderState === "sending" && <p className="adm-loading">Sending…</p>}
          {reminderState === "sent"    && <p className="adm-remind-sent">✓ Reminders sent to {alerts.length} student{alerts.length !== 1 ? "s" : ""}</p>}
          <table className="adm-report-table adm-alerts-table">
            <thead><tr><th>Student</th><th>Pass</th><th>Remaining</th><th>Expires</th><th>Alert</th></tr></thead>
            <tbody>
              {alerts.map((a, i) => (
                <tr key={i}>
                  <td>{a.studentEmail}</td><td>{a.passLabel}</td><td>{a.classesRemaining}</td>
                  <td>{a.expiresAt ? fmtDate(a.expiresAt) : "—"}</td><td>{a.reasons.join(" · ")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
}
